import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { ToastContext, ToastTypeEnum } from "context/toastContext";
import useIsCreate from "hooks/useIsCreate";
import { useUpdatePersonalTrialMutation } from "@generated/graphql";
import { getTestingPath } from "helpers/index";
import { parseApolloError } from "helpers/errorsParser";
import { UpdateTrialParams } from "../types";

const useUpdateTrial = () => {
  const navigate = useNavigate();
  const { addToast } = useContext(ToastContext);
  const isCreate = useIsCreate();

  const toggleToastOnSuccess = (text?: string) => addToast({ type: ToastTypeEnum.SUCCESS, text });
  const navigateToCreatedTesting = (id: string) => navigate(getTestingPath("trial", id));

  const [updateTrial, { loading: updateTrialLoading }] = useUpdatePersonalTrialMutation();

  const onUpdateTrial = ({ formData, candidateId, setIsEditing }: UpdateTrialParams) => {
    updateTrial({
      variables: {
        input: {
          id: formData.id,
          title: formData.title,
          competencyMapId: formData.competencyMap?.id,
          comment: formData.comment,
          companyCandidateId: candidateId,
        },
      },
    })
      .then((res) => {
        const createdId = res.data?.updatePersonalTrial.id;
        if (isCreate && createdId) {
          navigateToCreatedTesting(createdId);
        }
        setIsEditing(false);
        toggleToastOnSuccess();
      })
      .catch((e) => parseApolloError(e, { addToast }));
  };

  return { updateTrialLoading, onUpdateTrial };
};

export default useUpdateTrial;
